
const digest = 'deb98f8f97a2dfe0751558fd9752da67badcb2db21fc109d34771232ecee352d';
const css = `/* Hide the text selection if cells are selected. */
._tableCellsSelected_1csyj_2 ::selection {
  background-color: transparent;
}

._cellResizeHandle_1csyj_6 {
  display: block;
  position: absolute;
  right: -4px;
  top: 0;
  height: 100%;
  width: 7px;
  cursor: col-resize;
  z-index: 10;
}

._cellResizeHandleIndicator_1csyj_17 {
  display: block;
  position: absolute;
  top: -1px;
  bottom: -1px;
  left: 2px;
  width: 3px;
}

._cellResizeHandleActive_1csyj_26 ._cellResizeHandleIndicator_1csyj_17 {
  background-color: var(--aha-blue-400);
}

._selectionWithinCell_1csyj_30:before,
._cellSelectedBackground_1csyj_31:before {
  inset: 0 !important;
  content: '';
  position: absolute;
  pointer-events: none;
}

._selectionWithinCell_1csyj_30:before {
  border: 2px solid var(--aha-blue-400) !important;
}

._cellSelectedBackground_1csyj_31:before {
  background-color: rgba(var(--aha-editor-v2--selection-background-color), 0.5);
}

._cellSelectedBackground_1csyj_31 {
  * {
    --aha-editor-v2--selection-background-color: transparent;
  }
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"tableCellsSelected":"_tableCellsSelected_1csyj_2","cellResizeHandle":"_cellResizeHandle_1csyj_6","cellResizeHandleIndicator":"_cellResizeHandleIndicator_1csyj_17","cellResizeHandleActive":"_cellResizeHandleActive_1csyj_26","selectionWithinCell":"_selectionWithinCell_1csyj_30","cellSelectedBackground":"_cellSelectedBackground_1csyj_31"};
export { css, digest };
  